<template>
	<div class="grid grid-cols-2 gap-3">
		<LabeledObject v-if="sanctionable.created_at">
			<template #label>{{ trans('admin.users.boards.areas.workgroups.created_at') }}</template>
			<p class="text-blue-400 dark:text-blue-600">{{ dayjs(sanctionable.created_at).format(trans('general.dayjs.datetime')) }}</p>
		</LabeledObject>
		<LabeledObject v-if="sanctionable.upgraded_at">
			<template #label>{{ trans('admin.users.boards.areas.workgroups.upgraded_at') }}</template>
			<p class="text-purple-400 dark:text-purple-600">{{ dayjs(sanctionable.upgraded_at).format(trans('general.dayjs.datetime')) }}</p>
		</LabeledObject>
		<LabeledObject v-else-if="sanctionable.expelled_at">
			<template #label>{{ trans('admin.users.boards.areas.workgroups.expelled_at') }}</template>
			<p class="text-red-400 dark:text-red-600">{{ dayjs(sanctionable.expelled_at).format(trans('general.dayjs.datetime')) }}</p>
		</LabeledObject>
		<LabeledObject v-else-if="sanctionable.finished_at">
			<template #label>{{ trans('admin.users.boards.areas.workgroups.finished_at') }}</template>
			<p class="text-green-400 dark:text-green-600">{{ dayjs(sanctionable.finished_at).format(trans('general.dayjs.datetime')) }}</p>
		</LabeledObject>
	</div>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {trans} from 'laravel-vue-i18n'
import {defineProps, type Ref, ref} from 'vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type Sanctionable} from '@/Types/Association/Sanctionable'

const props = defineProps<{
	sanctionable:Sanctionable,
}>()

const sanctionable:Ref<Sanctionable> = ref(props.sanctionable)
</script>